import Section from "./ui/Section";

export default function CTA() {
  return (
    <Section className="bg-white dark:bg-[#0a0a0a]">
      <div className="relative overflow-hidden rounded-[3rem] bg-[#1a1a1a] dark:bg-[#111] px-6 py-20 md:px-20 text-center">
        {/* Decorative elements */}
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
          <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-[#C9A227]/20 rounded-full blur-[100px] translate-x-1/2 -translate-y-1/2"></div>
          <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-[#C9A227]/10 rounded-full blur-[100px] -translate-x-1/2 translate-y-1/2"></div>
        </div>

        <div className="relative z-10 max-w-3xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Ready to Digitalize Your Jewelry Business?
          </h2>
          <p className="text-xl text-gray-300 mb-10 leading-relaxed">
            Join the network of modern jewellers trusting CaratPay for their
            gold savings schemes and metal booking.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <button
              type="button"
              className="w-full sm:w-auto bg-[#C9A227] text-[#1a1a1a] px-8 py-4 rounded-full font-bold text-lg hover:bg-[#B8941F] transition-all hover:shadow-lg hover:shadow-[#C9A227]/30 transform hover:-translate-y-1"
            >
              Partner With Us
            </button>
            <button
              type="button"
              className="w-full sm:w-auto bg-white/10 backdrop-blur-sm text-white border border-white/20 px-8 py-4 rounded-full font-bold text-lg hover:bg-white/20 transition-all transform hover:-translate-y-1"
            >
              Contact Sales
            </button>
          </div>
        </div>
      </div>
    </Section>
  );
}
